// extracted by mini-css-extract-plugin
export default {"text":"ChildrenModeSeaGreeting_text__9jE1g"};